import { makeAutoObservable } from 'mobx';
import { IAdaptiveService } from '../../../../infrastructure/types/features/adaptive/adaptive-types';

class AdaptiveUIModule {
  constructor(private adaptiveService: IAdaptiveService) {
    makeAutoObservable(this, {});
  }

  get isMobile() {
    return this.adaptiveService.getTypeDevice() === 'mobile';
  }
}

export { AdaptiveUIModule };
